var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback"},[_c('feedback-add',{attrs:{"contract_id":_vm.contract_id}}),_c('feedback-list',{attrs:{"contract_id":_vm.contract_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }